import { useQuery } from '@tanstack/react-query';

import { api } from 'api/v1';

import type { BulletinsRequest } from './types';

export const useGetBulletins = (params: BulletinsRequest) => {
  return useQuery({
    queryKey: ['bulletins', params],
    queryFn: async () => {
      const response = await api.post('search_bulletins', params);
      return response.data;
    },
    refetchOnWindowFocus: true,
    staleTime: 0,
    refetchOnMount: 'always',
  });
};
